export default {"src":"/_next/static/media/PSX-QR.37146ea3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};